import { createContext } from "@smartsheet/lodestar-utils";
/**
 * This context should be used for things in Select and MultiSelect that don't expect to be changed during a
 * component's lifetime. This isn't a hard-n-fast rule, but this context can be a grab-bag of things we
 * want to propagate around these components. If some part of this context ends up changing frequently it
 * could hurt perf so we should break those things out if that becomes the case.
 *
 * @deprecated This component is being removed in V6+, February 2025, in favor of the `SelectV2/MultiSelectV2` components.
 */
export const StaticPropContext = createContext({}, "StaticPropContext");
//# sourceMappingURL=StaticPropContext.js.map